/**
 * Returns the price quote items for a given product
 **/
var getPriceQuoteItems = function getPriceQuoteItems(pricing) {
  var _pricing$eligibility$, _pricing$eligibility$2;
  return (_pricing$eligibility$ = pricing === null || pricing === void 0 || (_pricing$eligibility$2 = pricing.eligibility.pricePlans) === null || _pricing$eligibility$2 === void 0 || (_pricing$eligibility$2 = _pricing$eligibility$2.quoteItems) === null || _pricing$eligibility$2 === void 0 ? void 0 : _pricing$eligibility$2.priceQuoteItems) !== null && _pricing$eligibility$ !== void 0 ? _pricing$eligibility$ : [];
};
export default getPriceQuoteItems;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getPriceQuoteItems.js
// module id = 1431
// module chunks = 11